import { FC, useCallback, RefObject } from 'react';
import { useHookstate } from '@hookstate/core';
import { JackpotModal as JackpotModalComponent } from '../../components/JackpotModal';
import { useFormatCurrency } from '../../hooks/use-format-currency';
import { useFocusChat } from '../../hooks/use-focus-chat';
import {
    meta,
    current,
    jackpotWinner,
    closeJackpotModal,
} from '../../stores/backend';
import { chatMeta } from '../../stores/chat';
import { RoundedEmojiInputRef } from '../../components/RoundedEmojiInput';

type JackpotModalProps = {
    inputRef: RefObject<RoundedEmojiInputRef>;
};

export const JackpotModal: FC<JackpotModalProps> = ({ inputRef }) => {
    const $meta = useHookstate(meta);
    const $current = useHookstate(current);
    const $jackpotWinner = useHookstate(jackpotWinner);
    const $chatMeta = useHookstate(chatMeta);

    const formatCurrency = useFormatCurrency($current, $meta);

    const onClose = useCallback(() => {
        closeJackpotModal();
    }, []);

    // Chat input is focused again so users are not interrupted if they are chatting with others while this modal opens.
    const focusChat = useFocusChat(inputRef, $chatMeta);

    const jackpot = $jackpotWinner.value;

    // Amounts are in the jackpot currency, convert them to the display currency.
    const winners =
        jackpot?.winners.map((w) => {
            return {
                name: w.userAlias,
                amount: formatCurrency(w.amount, jackpot.currency),
            };
        }) ?? [];

    const totalJackpotAmount = jackpot
        ? formatCurrency(jackpot.amount, jackpot.currency)
        : '';

    return (
        <JackpotModalComponent
            isOpen={$meta.modals.jackpot.value}
            onClose={onClose}
            onAfterOpen={focusChat}
            winners={winners}
            totalJackpotAmount={totalJackpotAmount}
        />
    );
};
